import comp from "./SubjectBasedGradingWrapper";
export default comp;
